import 'slick-carousel';

const sliderInitial = '.slick-slider';
const sliderSelector = '.js-slider-testimonial';
const sliderDotsSelector = `${sliderSelector} .slider__dots`;

/**
 * Slide testimonial
 */
$(sliderInitial).slick({
 	arrows: false,
 	dots: true,
 	infinite: true,
 	speed: 600,
 	slidesToShow: 1,
 	appendDots: $(sliderDotsSelector),
});